import { render, staticRenderFns } from "./NumberCount.vue?vue&type=template&id=198a7458"
import script from "./NumberCount.vue?vue&type=script&lang=js"
export * from "./NumberCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports